export default function test(a) {
    if (a === undefined || a === null) return "Mandatory field";
    return true;
}
